import { ComponentRef, ViewContainerRef } from "@angular/core";
import { ChangeUsernameComponent } from "./change-username.component";


class ChangeUsernameFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    changeUsernameFormSessionCompRef: ComponentRef<ChangeUsernameComponent>;

    constructor(formId: string, payload: object) {
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.changeUsernameFormSessionCompRef = this.viewContainerRef.createComponent(ChangeUsernameComponent);
        this.changeUsernameFormSessionCompRef.instance.onSubmitNewUsername = this.onSubmitNewUseruserName.bind(this);

        this.changeUsernameFormSessionCompRef.instance.onChangeUsernameSkipClick = this.onChangeUsernameSkipSubmit.bind(this);
        this.changeUsernameFormSessionCompRef.instance.showPasskeyMessage = this.clientContext['showPasskeyMsg'];

        const journeyPayload = this.payload as JourneyPayload;

        const action = journeyPayload.actions[0] as ActionsInPayload;

        this.changeUsernameFormSessionCompRef.instance.flowFromPayload = 'changeUsername';

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              this.submitBlock = null;
            } catch (e) {
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
      }

      onError(payload: object): void {
        const userEmail = this.clientContext['cookieService'].get('userEmail');
        // const errorPayload = payload as JourneyPayload;

        if (payload['email'] === userEmail)
        {
          setTimeout(() => this.changeUsernameFormSessionCompRef.instance.setErrorCode('ECP4'), 100);
        }
        else if (payload['code'] === '0' && payload['stat'] === 'ok')
        {
          setTimeout(() => this.changeUsernameFormSessionCompRef.instance.setErrorCode('ECP3'), 100);
        }
        else
        {
          setTimeout(() => this.changeUsernameFormSessionCompRef.instance.setErrorCode(payload['code']), 100);
        }
      }

      private onSubmitNewUseruserName(payload: object) {
        this.clientContext['nextStep'] = 'changeUsernameFlow';
        const data = payload;
        this.submitBlock(data);
      }

      onChangeUsernameSkipSubmit = (code: string) => {
        const userEmail = this.clientContext['cookieService'].get('username');
        const url = this.clientContext['redirect_uri'];
        const state = this.clientContext['state'];
        const errorCode  = 'cancel_username';
        let appendChar = '?';
        if (url.includes('?'))
        {
           appendChar = '&';
        }
        window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=cancel_username' 
        + '&lang=' + this.clientContext['cookieService'].get('lang')
        + '&state=' + state;
      }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default ChangeUsernameFormSession;
